(ns ui.view.card.tasks.sub
  (:require
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.view.card.sub :as common-sub]
   [ui.state.session.sub :as session-sub]
   [ui.view.card.entity-list.util :as entity-list-util]))

(defn task? [entity]
  (= (:entity/type entity) :entity.type/task))

(rf/reg-sub
 ::tasks
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[card-entities-by-id] [_ ctx]]
   (let [primary-entity-id (:entity-id ctx)]
     (->> card-entities-by-id
          vals
          (filterv (fn [entity]
                     (and (task? entity)
                          (some #{primary-entity-id}
                                (:common/related-entities entity)))))))))

(rf/reg-sub
 ::tasks-count
 (fn [[_ ctx]]
   [(rf/subscribe [::tasks ctx])])
 (fn [[tasks]]
   (count tasks)))

(rf/reg-sub
 ::table-data
 (fn [[_ ctx]]
   [(rf/subscribe [::tasks ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/entities])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[tasks card-entities-by-id global-entities-by-id tenant tenant-schema]
      [_ {:keys [card] :as _ctx}]]
   (let [all-entities-by-id (merge global-entities-by-id card-entities-by-id)
         column-fields (->> card
                            :card/config
                            :table
                            :columns
                            (mapv :field))]
     (entity-list-util/entities->table-row-data
      {:entities tasks
       :column-fields column-fields
       :entities-by-id all-entities-by-id
       :tenant tenant
       :tenant-schema tenant-schema}))))
